// PDF.js, loaded on first use — ONE place for every screen that reads or draws a PDF in the browser (the PEP guest-ledger
// import, a billing document's countersigning). pdfjs-dist 4+ ships ES modules only and always runs its parser in a
// worker: the legacy build (for older browsers) and its worker file; webpack emits the worker as an asset from the
// `new URL(…, import.meta.url)`. Dynamic, so a screen that never opens a PDF never downloads it.
export const loadPdfjs = async () => {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString();
  }
  return pdfjs;
};
